import { render, staticRenderFns } from "./EditImage.vue?vue&type=template&id=18f988df&scoped=true"
import script from "./EditImage.vue?vue&type=script&lang=js"
export * from "./EditImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f988df",
  null
  
)

export default component.exports